import { render, staticRenderFns } from "./CircledTitle.vue?vue&type=template&id=6604d2c8&"
import script from "./CircledTitle.vue?vue&type=script&lang=ts&"
export * from "./CircledTitle.vue?vue&type=script&lang=ts&"
import style0 from "./CircledTitle.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports